import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';

@Component({
  selector: 'app-menu-panel-mobile',
  templateUrl: './menu-panel-mobile.component.html',
  styleUrls: ['./menu-panel-mobile.component.scss'],
})
export class MenuPanelMobileComponent implements OnInit {
  @ViewChildren('menuChildren')
  menuChildren!: QueryList<MenuPanelMobileComponent>;
  constructor() {}
  @Input() labelRetour = '';
  @Input() items!: any[];
  @Input() visible = false;
  @Input() idPanel!: string;
  @Output() sidenavClose = new EventEmitter();
  @Output() closePanel = new EventEmitter();

  idPanelCourant: string = '';
  showContent: boolean = true; // Flag pour contrôler l'affichage du contenu du menu actuel
  
  ngOnInit(): void {}

  onSidenavClose(menu: MenuPanelMobileComponent): void {
    this.toggle();
    this.sidenavClose.emit();
  }
  
  public toggle(): void {
    // Fermer tous les enfants
    this.menuChildren.toArray().forEach((elem) => {
      elem.visible = false;
      elem.showContent = true;
    });
    this.idPanelCourant = '';
    this.showContent = true;
    this.closePanel.emit();
  }
  
  public toggleChildren(): void {
    // Quand un enfant se ferme, on réaffiche le contenu du parent
    this.menuChildren.toArray().forEach((elem) => {
      if (elem.idPanel === this.idPanelCourant) {
        elem.visible = false;
        elem.showContent = true;
        this.idPanelCourant = '';
      }
    });
    this.showContent = true;
  }
  
  showPanel(idPanel: string): void {
    // Fermer tous les panneaux enfants d'abord
    this.menuChildren.toArray().forEach((elem) => {
      elem.visible = false;
      elem.showContent = true;
    });

    // Ouvrir uniquement le panneau ciblé
    this.menuChildren.toArray().forEach((elem) => {
      if (elem.idPanel === idPanel) {
        elem.visible = true;
        elem.showContent = true;
        this.idPanelCourant = idPanel;
      }
    });

    // Cacher le contenu du panneau parent (on montre seulement l'enfant)
    this.showContent = false;

    // Scroller vers le haut du menu pour voir le nouveau sous-menu
    setTimeout(() => {
      // Essayer de trouver le header du menu qui vient de s'ouvrir
      const headerMenu = document.querySelector('.header-menu');
      if (headerMenu) {
        // Scroller un peu au-dessus du header pour voir le titre complet
        const headerPosition = headerMenu.getBoundingClientRect().top;
        const offset = 80; // Offset pour voir le titre en haut
        window.scrollBy({
          top: headerPosition - offset,
          behavior: 'smooth'
        });
      } else {
        // Plan B : scroller le nav-list vers le haut
        const navList = document.querySelector('.nav-list-mobile');
        if (navList && navList.parentElement) {
          navList.parentElement.scrollTop = 0;
        }
      }
      
      // Focus sur le bouton retour après le scroll pour l'accessibilité clavier
      const backButton = document.getElementById(`back-${idPanel}`);
      if (backButton) {
        backButton.focus();
      }
    }, 150);
  }
}
